import script from "./MaterialOrderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialOrderForm.vue?vue&type=script&setup=true&lang=js"

import "./MaterialOrderForm.vue?vue&type=style&index=0&id=04f255fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f255fc"]])

export default __exports__